import { render, staticRenderFns } from "./MemberDetailAbsences.vue?vue&type=template&id=a938f61c"
import script from "./MemberDetailAbsences.vue?vue&type=script&lang=js"
export * from "./MemberDetailAbsences.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports